export function drawLabel(h, text, cx, cy, maxWidth, options = {}) {
  if (!text) return h('g', {});
  const fontSize = options.fontSize || 13;
  const fontWeight = options.fontWeight || 500;
  const anchor = options.anchor || 'middle';
  const x = options.xOverride != null ? options.xOverride : cx;

  const approxChar = fontSize * 0.55;
  const maxChars = Math.max(4, Math.floor(maxWidth / approxChar));

  const lines = wrapText(String(text), maxChars, 3);
  const total = lines.length;
  const baseline = cy - ((total - 1) * fontSize) / 2 + fontSize / 3;

  return h(
    'text',
    {
      x,
      y: baseline,
      textAnchor: anchor,
      fontSize,
      fontFamily: 'Arial, sans-serif',
      fontWeight,
      fill: options.fill || '#212121',
      style: { userSelect: 'none' },
    },
    lines.map((line, i) =>
      h('tspan', { x, dy: i === 0 ? 0 : fontSize }, line)
    )
  );
}

function wrapText(text, maxChars, maxLines) {
  const words = text.split(/\s+/);
  const lines = [];
  let cur = '';
  for (const w of words) {
    const attempt = cur ? `${cur} ${w}` : w;
    if (attempt.length > maxChars && cur) {
      lines.push(cur);
      cur = w;
      if (lines.length >= maxLines) break;
    } else {
      cur = attempt;
    }
  }
  if (cur && lines.length < maxLines) lines.push(cur);
  if (lines.length === maxLines && words.length > lines.join(' ').split(/\s+/).length) {
    const last = lines[lines.length - 1];
    lines[lines.length - 1] = last.length > maxChars - 1 ? last.slice(0, maxChars - 1) + '…' : last + '…';
  }
  return lines;
}
